module.exports = __webpack_public_path__ + "static/media/logo(ru).c4093bac.svg";